<div
  class="navigation-sidebar gw-flex gw-flex-col gw-items-start gw-bg-background-base gw-transition-all gw-duration-300 gw-ease-in-out"
  [class.navigation-collapsed]="isCollapsed"
  [class.navigation-expanded]="!isCollapsed"
>
  <div
    class="navigation-header gw-bg-background-neutral-1 gw-flex gw-items-center gw-justify-center gw-w-full gw-pt-x-small gw-pr-x-large gw-pb-x-small gw-pl-x-large gw-gap-2x-small gw-shrink-0 gw-box-border"
  >
    <span
      *ngIf="!isCollapsed && ((profile?.recipient?.name && typeof profile?.recipient?.name === 'string') || (profile?.domain?.name && typeof profile?.domain?.name === 'string'))"
      class="gw-text-sm gw-font-bold gw-text-text-secondary gw-truncate"
    >
      {{
        (
          (profile?.recipient?.name && typeof profile?.recipient?.name === 'string'
            ? profile?.recipient?.name
            : (profile?.domain?.name && typeof profile?.domain?.name === 'string'
                ? profile?.domain?.name
                : '')
          ) || ''
        ).toUpperCase()
      }}
    </span>
  </div>

  <div
    class="menu-items gw-flex gw-flex-col gw-flex-1 gw-pt-medium gw-pb-medium gw-overflow-y-auto gw-overflow-x-hidden"
  >
    <nav class="gw-w-full" [attr.aria-label]="'nav.aria.mainNav' | translate">
      <ul
        class="gw-flex gw-flex-col gw-list-none gw-m-0 gw-p-0 gw-gap-2x-small gw-w-full"
      >
        <li
          *ngFor="let item of sidebarMenu; let idx = index"
          class="gw-flex gw-flex-col"
          [class.active]="isActive(item.title, 'menu')"
        >
          <!-- ═══════════════════════ COLLAPSED MODE ═══════════════════════ -->

          <!-- Collapsed: simple link, no subMenu — anchor keeps right-click/middle-click -->
          <a
            *ngIf="isCollapsed && item.route && !item.subMenu?.length"
            [routerLink]="item.route"
            [tuiHint]="item.title | translate"
            tuiHintDirection="right"
            (click)="closeMobileNavIfNarrow()"
            class="gw-flex gw-items-center gw-justify-center gw-min-h-[32px] gw-w-full gw-rounded-lg gw-transition-all gw-duration-200 gw-cursor-pointer gw-no-underline"
            [ngClass]="{
              ' gw-text-text-primary': isActive(item.title, 'menu'),
              'gw-text-text-secondary ': !isActive(item.title, 'menu')
            }"
          >
            <gatewee-icon
              [icon]="item.icon || '@tui.circle'"
              size="16px"
            ></gatewee-icon>
          </a>

          <!-- Collapsed: icon with subMenu — flyout dropdown to the right -->
          <ng-container *ngIf="isCollapsed && item.subMenu?.length">
            <ng-template #collapsedFlyout>
              <gatewee-nav-flyout
                [item]="item"
                (optionSelected)="closeCollapsedDropdown(item.title)"
              ></gatewee-nav-flyout>
            </ng-template>

            <button
              type="button"
              [tuiDropdown]="collapsedFlyout"
              [(tuiDropdownOpen)]="collapsedOpenState[item.title]"
              tuiDropdownSided
              class="gw-flex gw-items-center gw-justify-center gw-min-h-[32px] gw-w-full gw-rounded-lg gw-b-none gw-bg-transparent gw-transition-all gw-duration-200 gw-cursor-pointer"
              [ngClass]="{
                ' gw-text-text-primary': isActive(item.title, 'menu'),
                'gw-text-text-secondary ': !isActive(item.title, 'menu')
              }"
            >
              <gatewee-icon
                [icon]="item.icon || '@tui.circle'"
                size="16px"
              ></gatewee-icon>
            </button>
          </ng-container>

          <!-- ═══════════════════════ EXPANDED MODE ═══════════════════════ -->

          <!-- Expanded: simple link, no subMenu -->
          <a
            *ngIf="!isCollapsed && item.route && !item.subMenu?.length"
            [routerLink]="item.route"
            (click)="closeMobileNavForTopLeaf(item)"
            class="gw-flex gw-min-w-0 gw-items-center gw-min-h-[32px] gw-px-2x-small gw-py-4x-small gw-rounded-lg gw-transition-all gw-duration-200 gw-cursor-pointer gw-w-full gw-box-border gw-leading-none gw-no-underline"
            [ngClass]="{
              ' gw-text-text-primary': isActive(item.title, 'menu'),
              'gw-text-text-secondary ': !isActive(item.title, 'menu')
            }"
          >
            <gatewee-icon
              [icon]="item.icon || '@tui.circle'"
              size="16px"
              class="gw-transition-colors gw-duration-200 gw-mr-2x-small gw-shrink-0"
            ></gatewee-icon>
            <span
              class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
              [attr.title]="item.title | translate"
              >{{ item.title | translate }}</span
            >
          </a>

          <!-- Expanded: item with subMenu — link only when parent has its own route;
               otherwise a button toggles the accordion (no fake link to first child). -->
          <div
            *ngIf="!isCollapsed && item.subMenu?.length"
            class="nav-split-row gw-flex gw-min-w-0 gw-items-stretch gw-w-full"
          >
            <a
              *ngIf="parentHasOwnRoute(item)"
              [routerLink]="item.route"
              (click)="onTopMenuLinkClick()"
              class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-min-h-[32px] gw-pl-2x-small gw-pr-4x-small gw-py-4x-small gw-rounded-l-lg gw-transition-all gw-duration-200 gw-cursor-pointer gw-leading-none gw-no-underline"
              [ngClass]="{
                ' gw-text-text-primary': isActive(item.title, 'menu'),
                'gw-text-text-secondary ': !isActive(item.title, 'menu')
              }"
            >
              <gatewee-icon
                [icon]="item.icon || '@tui.circle'"
                size="16px"
                class="gw-transition-colors gw-duration-200 gw-mr-2x-small gw-shrink-0"
              ></gatewee-icon>
              <span
                class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                [attr.title]="item.title | translate"
                >{{ item.title | translate }}</span
              >
            </a>
            <button
              *ngIf="!parentHasOwnRoute(item)"
              type="button"
              (click)="onTopMenuParentNoRouteClick(item)"
              class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-min-h-[32px] gw-pl-2x-small gw-pr-4x-small gw-py-4x-small gw-rounded-l-lg gw-transition-all gw-duration-200 gw-cursor-pointer gw-leading-none gw-text-left gw-font-inherit gw-b-none gw-bg-transparent"
              [ngClass]="{
                ' gw-text-text-primary': isActive(item.title, 'menu'),
                'gw-text-text-secondary ': !isActive(item.title, 'menu')
              }"
            >
              <gatewee-icon
                [icon]="item.icon || '@tui.circle'"
                size="16px"
                class="gw-transition-colors gw-duration-200 gw-mr-2x-small gw-shrink-0"
              ></gatewee-icon>
              <span
                class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                [attr.title]="item.title | translate"
                >{{ item.title | translate }}</span
              >
            </button>
            <button
              type="button"
              class="gw-navigation-expand-toggle gw-flex gw-shrink-0 gw-items-center gw-justify-center gw-min-h-[32px] gw-pr-2x-small gw-pl-4x-small gw-rounded-r-lg gw-b-none gw-bg-transparent gw-cursor-pointer gw-text-text-secondary gw-transition-colors gw-duration-200"
              [attr.aria-expanded]="isTopMenuOpen(item)"
              [attr.aria-controls]="'nav-submenu-' + idx"
              [attr.aria-label]="'nav.aria.toggleNestedLinks' | translate"
              [ngClass]="{
                ' gw-text-text-primary': isActive(item.title, 'menu'),
                '': !isActive(item.title, 'menu')
              }"
              (click)="toggleTopMenuExpand(item, $event)"
            >
              <gatewee-expand-chevron
                [expanded]="isTopMenuOpen(item)"
                size="16px"
              ></gatewee-expand-chevron>
            </button>
          </div>

          <!-- Submenu accordion (expanded mode only) -->
          <div
            *ngIf="item.subMenu?.length && !isCollapsed"
            class="nav-submenu-panel"
            [class.nav-submenu-panel--open]="isTopMenuOpen(item)"
          >
            <ul
              [id]="'nav-submenu-' + idx"
              class="nav-submenu-inner gw-flex gw-flex-col gw-list-none gw-m-0 gw-p-0 gw-gap-2x-small"
              role="list"
            >
              <li
                *ngFor="let subitem of item.subMenu"
                class="gw-flex gw-flex-col gw-w-full gw-max-w-[85%]"
                [class.active]="isActive(subitem.title, 'submenu')"
              >
                <!-- Sub: external / new tab -->
                <a
                  *ngIf="
                    !subitem.theme && subitem.route && subitem.openInNewTab
                  "
                  [attr.href]="externalHref(subitem.route)"
                  target="_blank"
                  rel="noopener noreferrer"
                  (click)="closeMobileNavForSubLeaf(subitem)"
                  class="gw-flex gw-min-w-0 gw-items-center gw-px-2x-small gw-py-2x-small gw-rounded-lg gw-text-xs gw-transition-all gw-duration-200 gw-cursor-pointer gw-w-full gw-no-underline"
                  [ngClass]="{
                    ' gw-text-text-primary': isActive(subitem.title, 'submenu'),
                    'gw-text-text-secondary ': !isActive(
                      subitem.title,
                      'submenu'
                    )
                  }"
                >
                  <span
                    class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                    [attr.title]="subitem.title | translate"
                    >{{ subitem.title | translate }}</span
                  >
                </a>

                <!-- Sub: internal link, no sub-submenu -->
                <a
                  *ngIf="
                    !subitem.theme &&
                    subitem.route &&
                    !subitem.openInNewTab &&
                    !subitem.subsubMenu?.length
                  "
                  [routerLink]="subitem.route"
                  (click)="closeMobileNavForSubLeaf(subitem)"
                  class="gw-flex gw-min-w-0 gw-items-center gw-px-2x-small gw-py-2x-small gw-rounded-lg gw-text-xs gw-transition-all gw-duration-200 gw-cursor-pointer gw-w-full gw-no-underline"
                  [ngClass]="{
                    ' gw-text-text-primary': isActive(subitem.title, 'submenu'),
                    'gw-text-text-secondary ': !isActive(
                      subitem.title,
                      'submenu'
                    )
                  }"
                >
                  <span
                    class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                    [attr.title]="subitem.title | translate"
                    >{{ subitem.title | translate }}</span
                  >
                  <span
                    *ngIf="subitem.subBadge"
                    class="gw-ml-2x-small gw-px-2x-small gw-py-4x-small gw-text-xs gw-font-semibold gw-rounded-full gw-bg-background-neutral-1 gw-text-text-secondary"
                    >New</span
                  >
                </a>

                <!-- Sub: route + sub-submenu (split row) -->
                <div
                  *ngIf="
                    !subitem.theme &&
                    subitem.route &&
                    !subitem.openInNewTab &&
                    subitem.subsubMenu?.length
                  "
                  class="nav-split-row gw-flex gw-min-w-0 gw-items-stretch gw-w-full nav-sub-submenu-row"
                  [ngClass]="{
                    'gw-text-text-primary': isActive(subitem.title, 'submenu'),
                    'gw-text-text-secondary': !isActive(
                      subitem.title,
                      'submenu'
                    )
                  }"
                >
                  <a
                    [routerLink]="subitem.route"
                    (click)="closeMobileNavForSubLeaf(subitem)"
                    class="gw-flex gw-min-w-0 gw-flex-1 gw-items-center gw-px-2x-small gw-py-2x-small gw-rounded-l-lg gw-text-xs gw-transition-all gw-duration-200 gw-cursor-pointer gw-no-underline"
                    [ngClass]="{
                      ' gw-text-text-primary': isActive(
                        subitem.title,
                        'submenu'
                      ),
                      'gw-text-text-secondary ': !isActive(
                        subitem.title,
                        'submenu'
                      )
                    }"
                  >
                    <span
                      class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                      [attr.title]="subitem.title | translate"
                      >{{ subitem.title | translate }}</span
                    >
                    <span
                      *ngIf="subitem.subBadge"
                      class="gw-ml-2x-small gw-px-2x-small gw-py-4x-small gw-text-xs gw-font-semibold gw-rounded-full gw-bg-background-neutral-1 gw-text-text-secondary"
                      >New</span
                    >
                  </a>
                  <button
                    type="button"
                    class="gw-navigation-expand-toggle gw-flex gw-shrink-0 gw-items-center gw-justify-center gw-px-2x-small gw-py-2x-small gw-rounded-r-lg gw-b-none gw-bg-transparent gw-cursor-pointer gw-text-inherit gw-transition-colors gw-duration-200"
                    [attr.aria-expanded]="isSubBranchOpen(item, subitem)"
                    [attr.aria-label]="'nav.aria.toggleNestedLinks' | translate"
                    [ngClass]="{
                      ' gw-text-text-primary': isActive(
                        subitem.title,
                        'submenu'
                      )
                    }"
                    (click)="toggleSubMenuExpand(item, subitem, $event)"
                  >
                    <gatewee-expand-chevron
                      [expanded]="isSubBranchOpen(item, subitem)"
                      size="16px"
                    ></gatewee-expand-chevron>
                  </button>
                </div>

                <!-- Theme mode submenu item -->
                <button
                  *ngIf="subitem.theme"
                  (click)="themeMode(subitem.theme)"
                  type="button"
                  class="gw-flex gw-min-w-0 gw-items-center gw-px-2x-small gw-py-2x-small gw-rounded-lg gw-text-xs gw-transition-all gw-duration-200 gw-cursor-pointer gw-w-full"
                  [ngClass]="{
                    ' gw-text-text-primary': subitem.theme === elementValue,
                    'gw-text-text-secondary ': subitem.theme !== elementValue
                  }"
                >
                  <span
                    class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                    [attr.title]="subitem.title | translate"
                    >{{ subitem.title | translate }}</span
                  >
                </button>

                <!-- Sub-submenu accordion -->
                <div
                  *ngIf="subitem.subsubMenu?.length"
                  class="nav-subsub-panel"
                  [class.nav-subsub-panel--open]="
                    isSubBranchOpen(item, subitem)
                  "
                >
                  <ul
                    class="nav-subsub-inner gw-flex gw-flex-col gw-list-none gw-m-0 gw-p-0 gw-gap-2x-small"
                    role="list"
                  >
                    <li
                      *ngFor="let subSubItem of subitem.subsubMenu"
                      class="gw-w-full gw-max-w-[85%]"
                    >
                      <a
                        [routerLink]="subSubItem.route"
                        (click)="closeMobileNavIfNarrow()"
                        class="gw-flex gw-min-w-0 gw-items-center gw-px-2x-small gw-py-2x-small gw-rounded-lg gw-text-xs gw-transition-all gw-duration-200 gw-cursor-pointer gw-w-full gw-no-underline"
                        [ngClass]="{
                          ' gw-text-text-primary': isActive(
                            subSubItem.title,
                            'subsubmenu'
                          ),
                          'gw-text-text-secondary ': !isActive(
                            subSubItem.title,
                            'subsubmenu'
                          )
                        }"
                      >
                        <span
                          class="gw-w-1 gw-h-1 gw-rounded-full gw-mr-2x-small gw-shrink-0"
                          [ngClass]="{
                            'gw-bg-text-primary': isActive(
                              subSubItem.title,
                              'subsubmenu'
                            ),
                            'gw-bg-text-tertiary': !isActive(
                              subSubItem.title,
                              'subsubmenu'
                            )
                          }"
                        ></span>
                        <span
                          class="gw-min-w-0 gw-flex-1 gw-truncate gw-text-left"
                          [attr.title]="subSubItem.title | translate"
                          >{{ subSubItem.title | translate }}</span
                        >
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </nav>
  </div>

  <!-- Navigation Footer -->
  <div
    class="navigation-footer gw-mt-auto gw-flex gw-items-center gw-justify-center gw-pt-2x-small gw-pr-x-large gw-pb-2x-small gw-pl-x-large gw-gap-2x-small gw-bg-background-neutral-1 gw-box-border"
    [class.gw-justify-center]="isCollapsed"
  >
    <button
      type="button"
      (click)="toggleNavigation()"
      class="gw-flex gw-flex-row gw-justify-center gw-items-center gw-p-0 gw-gap-3x-small gw-h-4 gw-text-xs gw-font-normal gw-leading-4 gw-tracking-[0.4px] gw-cursor-pointer gw-b-none gw-bg-transparent gw-w-full"
      [attr.aria-label]="'nav.aria.collapseSidebar' | translate"
    >
      <gatewee-icon
        [icon]="isCollapsed ? '@tui.chevrons-right' : '@tui.chevrons-left'"
        class="gw-text-text-secondary"
        size="16px"
      ></gatewee-icon>
      <span class="gw-text-text-secondary" *ngIf="!isCollapsed">{{
        'nav.aria.collapseSidebarLabel' | translate
      }}</span>
    </button>
  </div>
</div>
